<template>
  <div>
    <div v-if="state.error" role="alert" class="organization-feedback">
      <p>{{ state.error }}</p>
      <button type="button" class="btn btn-link" :disabled="state.loading || state.saving" @click="retry">Повторити читання</button>
    </div>
    <modal name="request-organization" :adaptive="true" height="auto" @before-close="dismiss">
      <div class="organization-dialog" role="dialog" aria-modal="true" aria-labelledby="organization-title">
        <button type="button" class="btn btn-link" aria-label="Закрити" @click="cancel">×</button>
        <h3 id="organization-title" class="modal-title">Оберіть організацію</h3>
        <p>Збережіть організацію перед оформленням заявки або замовлення.</p>
        <label for="initial-organization">Організація</label>
        <select id="initial-organization" v-model="state.selected" class="input" :disabled="state.saving">
          <option value="" disabled>Оберіть організацію</option>
          <option v-for="item in organizations" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
        <p v-if="state.error" role="alert">{{ state.error }}</p>
        <div class="btn-holder">
          <button type="button" class="btn btn-main" :disabled="!validSelection || state.saving" @click="confirm">Підтвердити</button>
        </div>
        <div class="btn-holder">
          <button type="button" class="btn btn-link" @click="cancel">Скасувати</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { organizationFlow } from '../../helpers/requestOrganization'

export default {
  data: () => ({ state: organizationFlow.state }),
  mounted () {
    if (this.state.promptOpen) this.$modal.show('request-organization')
  },
  computed: {
    organizations () { return this.state.data ? this.state.data.organizations : [] },
    validSelection () { return this.organizations.some(item => String(item.id) === String(this.state.selected)) }
  },
  watch: {
    'state.promptOpen' (open) {
      if (open) this.$modal.show('request-organization')
      else this.$modal.hide('request-organization')
    }
  },
  methods: {
    cancel () { organizationFlow.cancelPrompt() },
    dismiss () { if (this.state.promptOpen) this.cancel() },
    confirm () { return organizationFlow.confirm() },
    retry () { return organizationFlow.refresh().catch(() => {}) }
  }
}
</script>

<style scoped>
.organization-dialog { padding: 20px; }
.organization-dialog select { width: 100%; margin: 12px 0; }
.organization-feedback { padding: 12px; }
</style>
